import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  TIMESHEET_GET_REQUEST,
  TIMESHEET_GET_SUCCESS,
  TIMESHEET_GET_FAILURE,
  TIMESHEET_GET_RESET,
  TIMESHEET_EDIT_REQUEST,
  TIMESHEET_EDIT_SUCCESS,
  TIMESHEET_EDIT_FAILURE,
  TIMESHEET_EDIT_RESET,
  MY_TIMESHEET_GET_REQUEST,
  MY_TIMESHEET_GET_SUCCESS,
  MY_TIMESHEET_GET_FAILURE,
  MY_TIMESHEET_GET_RESET,
  MY_TIMESHEET_SET_INVALID_INPUT,
  MY_TIMESHEET_RESET_INVALID_INPUT,
  TIMESHEET_GET_PROJECTS_REQUEST,
  TIMESHEET_GET_PROJECTS_SUCCESS,
  TIMESHEET_GET_PROJECTS_FAILURE,
  TIMESHEET_GET_PROJECTS_RESET,
  TIMESHEET_SUBMIT_REQUEST,
  TIMESHEET_SUBMIT_SUCCESS,
  TIMESHEET_SUBMIT_FAILURE,
  TIMESHEET_SUBMIT_RESET,
  TIMESHEET_STATUS_REQUEST,
  TIMESHEET_STATUS_SUCCESS,
  TIMESHEET_STATUS_FAILURE,
  TIMESHEET_STATUS_RESET,
  TIMESHEET_REQUEST_GET_REQUEST,
  TIMESHEET_REQUEST_GET_SUCCESS,
  TIMESHEET_REQUEST_GET_FAILURE,
  TIMESHEET_REQUEST_GET_RESET,
  TIMESHEET_REDIRECT_SET,
  TIMESHEET_APPROVE_REQUEST,
  TIMESHEET_APPROVE_SUCCESS,
  TIMESHEET_APPROVE_FAILURE,
  TIMESHEET_APPROVE_RESET,
  TIMESHEET_EXPORT_REQUEST,
  TIMESHEET_EXPORT_SUCCESS,
  TIMESHEET_EXPORT_FAILURE,
  TIMESHEET_EXPORT_RESET,
  TIMESHEET_CANCEL_REQUEST,
  TIMESHEET_CANCEL_SUCCESS,
  TIMESHEET_CANCEL_FAILURE,
  TIMESHEET_CANCEL_RESET,
  MY_TIMESHEET_EXPORT_REQUEST,
  MY_TIMESHEET_EXPORT_SUCCESS,
  MY_TIMESHEET_EXPORT_FAILURE,
  MY_TIMESHEET_EXPORT_RESET,
  SHOW_MANUAL_TIMESHEET,
  CLOSE_MANUAL_TIMESHEET,
  TIMSHEET_STATUS_SET_OPTIONS,
} from './../../constants'

export function getTimesheets(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/timesheets`,
      method: 'GET',
      types: [
        TIMESHEET_GET_REQUEST,
        TIMESHEET_GET_SUCCESS,
        TIMESHEET_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function getMyTimesheet(month, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/timesheets/my/${month}`,
      method: 'GET',
      types: [
        MY_TIMESHEET_GET_REQUEST,
        MY_TIMESHEET_GET_SUCCESS,
        MY_TIMESHEET_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function editTimesheets(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/timesheets`,
      method: 'PUT',
      types: [
        TIMESHEET_EDIT_REQUEST,
        TIMESHEET_EDIT_SUCCESS,
        TIMESHEET_EDIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function getTimesheetByProjects(projectID, month, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/timesheets/project/${projectID}/${month}`,
      method: 'GET',
      types: [
        TIMESHEET_GET_PROJECTS_REQUEST,
        TIMESHEET_GET_PROJECTS_SUCCESS,
        TIMESHEET_GET_PROJECTS_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function submitTimesheet(timesheetID, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/timesheets/${timesheetID}/submit`,
      method: 'POST',
      types: [
        TIMESHEET_SUBMIT_REQUEST,
        TIMESHEET_SUBMIT_SUCCESS,
        TIMESHEET_SUBMIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function getTimesheetStatus(startMonth, endMonth, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/timesheets/status?start_month=${startMonth}&end_month=${endMonth}`,
      method: 'GET',
      types: [
        TIMESHEET_STATUS_REQUEST,
        TIMESHEET_STATUS_SUCCESS,
        TIMESHEET_STATUS_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function getTimesheetRequest(requestID, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/timesheets/request/${requestID}`,
      method: 'GET',
      types: [
        TIMESHEET_REQUEST_GET_REQUEST,
        TIMESHEET_REQUEST_GET_SUCCESS,
        TIMESHEET_REQUEST_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function approveTimesheet(requestID, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/timesheets/${requestID}/approve`,
      method: 'POST',
      types: [
        TIMESHEET_APPROVE_REQUEST,
        TIMESHEET_APPROVE_SUCCESS,
        TIMESHEET_APPROVE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function cancelTimesheet(requestID, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/timesheets/${requestID}/cancel`,
      method: 'POST',
      types: [
        TIMESHEET_CANCEL_REQUEST,
        TIMESHEET_CANCEL_SUCCESS,
        TIMESHEET_CANCEL_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function exportTimesheetByProject(projectID, startMonth, endMonth, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/timesheets/project/${projectID}/exports?start_month=${startMonth}&end_month=${endMonth}`,
      method: 'GET',
      types: [
        TIMESHEET_EXPORT_REQUEST,
        TIMESHEET_EXPORT_SUCCESS,
        TIMESHEET_EXPORT_FAILURE,
      ],
      options: { timeout: (20 * 60 * 1000) },
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function exportTimesheetByLOB(lobID, startMonth, endMonth, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/timesheets/lob/${lobID}/exports?start_month=${startMonth}&end_month=${endMonth}`,
      method: 'GET',
      types: [
        TIMESHEET_EXPORT_REQUEST,
        TIMESHEET_EXPORT_SUCCESS,
        TIMESHEET_EXPORT_FAILURE,
      ],
      options: { timeout: (20 * 60 * 1000) },
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function exportMyTimesheet(requestID, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/timesheets/my-timesheet/${requestID}/exports`,
      method: 'GET',
      types: [
        MY_TIMESHEET_EXPORT_REQUEST,
        MY_TIMESHEET_EXPORT_SUCCESS,
        MY_TIMESHEET_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function openManual() {
  return {
    type: SHOW_MANUAL_TIMESHEET,
  }
}
export function closeManual() {
  return {
    type: CLOSE_MANUAL_TIMESHEET,
  }
}
export function setInvalidInput(payload) {
  return {
    type: MY_TIMESHEET_SET_INVALID_INPUT,
    payload,
  }
}
export function resetInvalidInput() {
  return {
    type: MY_TIMESHEET_RESET_INVALID_INPUT,
  }
}
export function setRedirect(payload) {
  return {
    type: TIMESHEET_REDIRECT_SET,
    payload,
  }
}
export function resetGetTimesheets() {
  return {
    type: TIMESHEET_GET_RESET,
  }
}
export function resetGetMyTimesheet() {
  return {
    type: MY_TIMESHEET_GET_RESET,
  }
}
export function resetEditTimesheets() {
  return {
    type: TIMESHEET_EDIT_RESET,
  }
}
export function resetGetTimesheetByProjects() {
  return {
    type: TIMESHEET_GET_PROJECTS_RESET,
  }
}
export function resetSubmitTimesheet() {
  return {
    type: TIMESHEET_SUBMIT_RESET,
  }
}
export function resetGetTimesheetStatus() {
  return {
    type: TIMESHEET_STATUS_RESET,
  }
}
export function resetGetTimesheetRequest() {
  return {
    type: TIMESHEET_REQUEST_GET_RESET,
  }
}
export function resetApproveTimesheet() {
  return {
    type: TIMESHEET_APPROVE_RESET,
  }
}
export function resetExportTimesheet() {
  return {
    type: TIMESHEET_EXPORT_RESET,
  }
}
export function resetExportMyTimesheet() {
  return {
    type: MY_TIMESHEET_EXPORT_RESET,
  }
}
export function resetCancelTimesheet() {
  return {
    type: TIMESHEET_CANCEL_RESET,
  }
}
export function setOptionsTimesheetStatus(payload) {
  return {
    type: TIMSHEET_STATUS_SET_OPTIONS,
    payload,
  }
}



// WEBPACK FOOTER //
// ./src/actions/timesheet/timesheet-action.js